import getVpNamesAndIds from './vpNameAndId';
import _ from 'lodash';

class VpAssessment {

    evaluateLimit(patientValue, vpData) {
        //Some limits use measusre limit,  some use an interval and some use bool
        if (vpData.interval === null && vpData.measurelimit === null) {
            return patientValue === true;
        }

        if (vpData.interval !== null) {
            return parseFloat(patientValue) <= vpData.interval.high && parseFloat(patientValue) >= vpData.interval.low;
        }

        if (vpData.measurelimit !== null) {
            switch (vpData.measurelimit.operator) {
                case ">":
                    return parseFloat(patientValue) > vpData.measurelimit.value;
                    break;
                case "≥":
                    return parseFloat(patientValue) >= vpData.measurelimit.value;
                    break;
                case "<":
                    return parseFloat(patientValue) < vpData.measurelimit.value;
                    break;
                case "≤":
                    return parseFloat(patientValue) <= vpData.measurelimit.value;
                    break;
                case "=":
                    return parseFloat(patientValue) === vpData.measurelimit.value;
                    break;
                default:
                    return false;
            }
        }
    }

    sortListByRiskLevel(listOfAssessments) {
        return _.orderBy(listOfAssessments, v => v.essRisklevel);
    }

    getMissingVpParameters (vpValue, ageGroup) {
        let missingVpValues = [];
        if (_.get(vpValue, ['A', 'airway']) === undefined || _.get(vpValue, ['A', 'airway']) === null || _.get(vpValue, ['A', 'airway']) === '')
            missingVpValues.push('AIRWAY');
        if (_.get(vpValue, ['B', 'respiratory_rate']) === undefined || _.get(vpValue, ['B', 'respiratory_rate']) === '')
            missingVpValues.push('RESPIRATORY_RATE');
        if (_.get(vpValue, ['B', 'spo2']) === undefined || _.get(vpValue, ['B', 'spo2']) === '')
            missingVpValues.push('SpO2');
        if (_.get(vpValue, ['C', 'heart_rate']) === undefined || _.get(vpValue, ['C', 'heart_rate']) === '')
            missingVpValues.push('HEART_RATE');
        if(parseInt(ageGroup) === 9){
            if (_.get(vpValue, ['C', 'sbp']) === undefined || _.get(vpValue, ['C', 'sbp']) === '') {
                missingVpValues.push('SBP');
            }
        }
        if (_.get(vpValue, ['D', 'consciousness_value']) === undefined || _.get(vpValue, ['D', 'consciouness']) === '')
            missingVpValues.push('CONSCIOUSNESS_VALUE');
        if (_.get(vpValue, ['E', 'temp']) === undefined || _.get(vpValue, ['E', 'temp']) === '')
            missingVpValues.push('TEMP');

        return missingVpValues;
    }

    getOverAllAssessment(vpValue, vpData, ageGroup) {
        const assessmentObject = this.assess(vpValue, vpData);

        //Checks that all mandantory fields are filled in, otherwise returns null
        if (_.get(vpValue, ['A', 'airway']) === undefined || _.get(vpValue, ['A', 'airway']) === null || _.get(vpValue, ['A', 'airway']) === '')
            return null;
        if (_.get(vpValue, ['B', 'respiratory_rate']) === undefined || _.get(vpValue, ['B', 'respiratory_rate']) === '')
            return null;
        if (_.get(vpValue, ['B', 'spo2']) === undefined || _.get(vpValue, ['B', 'spo2']) === '')
            return null;
        if ((_.get(vpValue, ['C', 'heart_rate']) === undefined || _.get(vpValue, ['C', 'heart_rate']) === '') && !_.get(vpValue, ['C', 'crying']))
            return null;
        if(parseInt(ageGroup) === 9){
            if (_.get(vpValue, ['C', 'sbp']) === undefined || _.get(vpValue, ['C', 'sbp']) === '')
                return null;
        }
        if (_.get(vpValue, ['D', 'consciousness_value']) === undefined || _.get(vpValue, ['D', 'consciouness']) === '')
            return null;
        if (_.get(vpValue, ['E', 'temp']) === undefined || _.get(vpValue, ['E', 'temp']) === '')
            return null;

        //Take object properties and convert to an array
        let assessmentList = [];
        Object.keys(assessmentObject).forEach((key) => {
            Object.keys(assessmentObject[key]).forEach((prop) => {
                if(assessmentObject[key][prop] === undefined) {
                    assessmentList.push({essRisklevel: -1}); //-1 means that the vp is undefined and can not be correcly assessed
                } else {
                    !(_.get(vpValue, ['C', 'crying']) && ((prop === 'heart_rate') || (prop === 'corrected_heart_rate')))
                    && assessmentList.push(assessmentObject[key][prop]);
                }
            });
        });
        //Returns object with highest essRisklevel
        return this.sortListByRiskLevel(assessmentList)[0];
    }

    //vpValue = patient input, vpData = RETTS VP
    assess(vpValue, vpData) {
        const group = _.chain(vpData.vpList)
            .groupBy('vpCategory')
            .map((vpList, vpCategory) => ({vpList, vpCategory}))
            .value();
        //Group Vp into categories
        const rettsVpA = group.filter(item => {
            if (item.vpCategory === "A") return item.vpList
        })[0];
        const rettsVpB = group.filter(item => {
            if (item.vpCategory === "B") return item.vpList
        })[0];
        const rettsVpC = group.filter(item => {
            if (item.vpCategory === "C") return item.vpList
        })[0];
        const rettsVpD = group.filter(item => {
            if (item.vpCategory === "D") return item.vpList
        })[0];
        const rettsVpE = group.filter(item => {
            if (item.vpCategory === "E") return item.vpList
        })[0];

        //key value for vpParameters id and vp names
        const vpKeyValueMap = getVpNamesAndIds();
        let assessmentObject = {A: {}, B: {}, C: {}, D: {}, E: {}};

        /* Create assessment object */
        //A Airway
        if (rettsVpA && vpValue.A) {
            //airway
            const vpParameterId = vpKeyValueMap[vpValue.A.airway];
            const vpAssessmentObject_airway = rettsVpA.vpList.find(x => x.vpParameter === vpParameterId);
            if (vpAssessmentObject_airway !== undefined || vpAssessmentObject_airway !== null) {
                assessmentObject.A.airway = vpAssessmentObject_airway;
            } else {
                delete assessmentObject.A.airway;
            }

        }

        //B Respiratory rate
        if (rettsVpB && vpValue.B) {
            const respitoryRateValue = _.get(vpValue, ['B', 'respiratory_rate']);
            if (respitoryRateValue) {
                const vpParameterId1 = vpKeyValueMap['respiratory_rate'];
                const assessmentListOfRespRate = rettsVpB.vpList.filter(vp => {
                    if (vp.vpParameter === vpParameterId1) {
                        return this.evaluateLimit(respitoryRateValue, vp);
                    } else {
                        return;
                    }
                });
                if (assessmentListOfRespRate.length > 0) {
                    assessmentObject.B.respiratory_rate = this.sortListByRiskLevel(assessmentListOfRespRate)[0];
                } else {
                    delete assessmentObject.B.respiratory_rate;
                }
            }

            //B SPO2 with or without O2
            let vpParameterId_O2 = vpKeyValueMap['spo2_without_o2'];
            if (vpValue.B.hasOxygen) {
                vpParameterId_O2 = vpKeyValueMap['spo2_with_o2'];
            }

            if (vpValue.B.spo2) {
                const assessmentListOfSpo2 = rettsVpB.vpList.filter(vp => {
                    if (vp.vpParameter === vpParameterId_O2) {
                        return this.evaluateLimit(vpValue.B.spo2, vp);
                    } else {
                        return false;
                    }
                });
                if (assessmentListOfSpo2.length > 0) {
                    assessmentObject.B.spo2 = this.sortListByRiskLevel(assessmentListOfSpo2)[0];
                } else {
                    delete assessmentObject.B.spo2;
                }
            }
        }

        //C Heart Rate, rythm and SBP
        if (rettsVpC && vpValue.C) {
            let vpParameterId_Rythm = vpKeyValueMap['regular_rhythm'];
            if (vpValue.C.rythm === 'irregular_rhythm') {
                vpParameterId_Rythm = vpKeyValueMap['irregular_rhythm'];
            }
            const vpParameter_heartRate = vpKeyValueMap['heart_rate'];
            if (vpValue.C.heart_rate) {
                const assessmentListOfHeartRate = rettsVpC.vpList.filter(vp => {
                    //evaluate heart rate with rythm in consideration
                    if (vp.vpParameter === vpParameterId_Rythm) {
                        return this.evaluateLimit(vpValue.C.heart_rate, vp);
                    }
                    //evaluating heart rate without rythm in consideration
                    if (vp.vpParameter === vpParameter_heartRate) {
                        return this.evaluateLimit(vpValue.C.heart_rate, vp);
                    } else {
                        return false;
                    }
                });
                if (assessmentListOfHeartRate.length > 0) {
                    assessmentObject.C.heart_rate = this.sortListByRiskLevel(assessmentListOfHeartRate)[0];
                } else {
                    delete assessmentObject.B.heart_rate;
                }
            }

            if (vpValue.C.corrected_heart_rate) {
                const assessmentListOfCorrectedHeartRate = rettsVpC.vpList.filter(vp => {
                    //evaluate heart rate with rythm in consideration
                    if ((vp.vpParameter === vpParameterId_Rythm) && vpValue.C.corrected_heart_rate) {
                        return this.evaluateLimit(vpValue.C.corrected_heart_rate, vp);
                    }

                    if ((vp.vpParameter === vpParameter_heartRate) && vpValue.C.corrected_heart_rate) {
                        return this.evaluateLimit(vpValue.C.corrected_heart_rate, vp);
                    } 
                        return false;
                    
                });
                if (assessmentListOfCorrectedHeartRate.length > 0) {
                    assessmentObject.C.corrected_heart_rate = this.sortListByRiskLevel(assessmentListOfCorrectedHeartRate)[0];
                } else {
                    delete assessmentObject.B.corrected_heart_rate;
                }
            }
            //C Systolic blood preasure (SBP)
            if (rettsVpC && vpValue.C) {
                //Makes the value initially risklevel 4 so it will be green if it is over 90
                if(vpValue.C.sbp > 1) {
                    assessmentObject.C.sbp = {essRisklevel: 4};
                }

                const vpParameterId_spb = vpKeyValueMap['sbp'];
                const assessmentListOfSBP = rettsVpC.vpList.filter(vp => {
                    //evaluate SP
                    if (vp.vpParameter === vpParameterId_spb) {
                        return this.evaluateLimit(vpValue.C.sbp, vp);
                    } else {
                        return false;
                    }
                });
                if (assessmentListOfSBP.length > 0) {
                    assessmentObject.C.sbp = this.sortListByRiskLevel(assessmentListOfSBP)[0];
                } else {
                    delete assessmentObject.B.sbp;
                }
            }
        }

        //D Consciousness and seizures
        if (rettsVpD && vpValue.D) {
            let assessmentListOfConsciouness;

            //evaluate consciouness
            //RLS
            if (vpValue.D.consciousness_scale === 'RLS') {
                const vpParameterId_rls = vpKeyValueMap['rls'];
                assessmentListOfConsciouness = rettsVpD.vpList.filter(vp => {
                    if (vp.vpParameter === vpParameterId_rls) {
                        return this.evaluateLimit(vpValue.D.consciousness_value, vp);
                    } else {
                        return false;
                    }
                });
            }
            //GCS
            if (vpValue.D.consciousness_scale === 'GCS') {
                const vpParameterId_gcs = vpKeyValueMap['gcs'];
                assessmentListOfConsciouness = rettsVpD.vpList.filter(vp => {
                    if (vp.vpParameter === vpParameterId_gcs) {
                        return this.evaluateLimit(vpValue.D.consciousness_value, vp);
                    } else {
                        return false;
                    }
                });
            }

            if (assessmentListOfConsciouness.length > 0) {
                assessmentObject.D.consciouness = this.sortListByRiskLevel(assessmentListOfConsciouness)[0];
            } else {
                delete assessmentObject.D.consciouness;
            }

            //D Seizure
            if (vpValue.D.seizures) {
                const vpParameterId_seizures = vpKeyValueMap['seizures'];
                const assessmentListOfSeizures = rettsVpD.vpList.filter(vp => {
                    if (vp.vpParameter === vpParameterId_seizures) {
                        return this.evaluateLimit(vpValue.D.seizures, vp);
                    } else {
                        return false;
                    }
                });
                if (assessmentListOfSeizures.length > 0) {
                    assessmentObject.D.seizures = this.sortListByRiskLevel(assessmentListOfSeizures)[0];
                } else {
                    delete assessmentObject.D.seizures;
                }
            }
        }

        //E Temp Hb and B-glucose
        if (rettsVpE && vpValue.E) {
            if (vpValue.E.temp) {
                const vpParameterId_temp = vpKeyValueMap['temp'];
                const assessmentListOfTemp = rettsVpE.vpList.filter(vp => {
                    if (vp.vpParameter === vpParameterId_temp) {
                        return this.evaluateLimit(vpValue.E.temp, vp);
                    } else {
                        return false;
                    }
                });
                if (assessmentListOfTemp.length > 0) {
                    assessmentObject.E.temp = this.sortListByRiskLevel(assessmentListOfTemp)[0];
                } else {
                    delete assessmentObject.E.temp;
                }
            }

            //This value is not in rettsonline VP-schema and therefore hardcoded...
            //Glucose
            if (vpValue.E.glucose) {
                const glucoseLevel = vpValue.E.glucose;
                assessmentObject.E.glucose = {essRisklevel: 4};
                if (glucoseLevel < 3 || glucoseLevel > 25) {
                    assessmentObject.E.glucose = {essRisklevel: 2};
                }
                if (glucoseLevel >= 15 && glucoseLevel <= 25) {
                    assessmentObject.E.glucose = {essRisklevel: 3};
                }

                if (vpValue.E.glucose === '' && assessmentObject.E.glucose) {
                    delete assessmentObject.E.glucose
                }
            }

            //Hb
            if (vpValue.E.hb) {
                const hbLevel = vpValue.E.hb;
                assessmentObject.E.hb = {essRisklevel: 4};
                if (hbLevel < 90) {
                    assessmentObject.E.hb = {essRisklevel: 2};
                }
                if (hbLevel < 70) {
                    assessmentObject.E.hb = {essRisklevel: 1};
                }

                if (vpValue.E.hb === '' && assessmentObject.E.hb) {
                    delete assessmentObject.E.hb;
                }

            }

        }
        return assessmentObject;
    }
}

const vpAssessment = new VpAssessment();
export default vpAssessment;


// WEBPACK FOOTER //
// ./retts/Assessment/vpAssessment.js